routing.$inject = [ '$urlRouterProvider', '$locationProvider', '$stateProvider', '$translateProvider' ]

export default function routing($urlRouterProvider, $locationProvider, $stateProvider, $translateProvider) {
	let config = require('../local.env.json')
	var clientName = config.clientName

	config.AVAILABLE_LANG = config.AVAILABLE_LANG || [ 'es' ]

	// Global site tag - Google Analytics 
	var newScript = document.createElement('script')

	newScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + config.analyticKey
	document.head.appendChild(newScript)
	var newScript = document.createElement('script')
	var inlineText = `    window.dataLayer = window.dataLayer || [];
                        function gtag (){dataLayer.push (arguments);}
                        gtag ('js', new Date ());
                        gtag ('config',"` + config.analyticKey + `");`
	var inlineScript = document.createTextNode(inlineText)

	newScript.appendChild(inlineScript)
	document.head.appendChild(newScript)

	//

	let translationsConfig = {}

	for (let i in config.AVAILABLE_LANG) {
		try {
			translationsConfig[config.AVAILABLE_LANG[i]] = require('./lang/' + config.clientName + '_' + config.AVAILABLE_LANG[i] + '.json')
		} catch (error) {
			translationsConfig[config.AVAILABLE_LANG[i]] = require('./lang/uplanner_' + config.AVAILABLE_LANG[i] + '.json')
		}
	}

	for (let lang in translationsConfig) {
		$translateProvider.translations(lang, translationsConfig[lang])
	}

	$translateProvider.preferredLanguage('es')

	$locationProvider.html5Mode(true)
	$urlRouterProvider.otherwise('/app/welcomeHome')
	$stateProvider
		.state('app', {
			url     : '/app',
			abstract: false,
			views   : {
				'': {
					template: require('./layout/layout.html'),
				},
				'content': {
					template: require('./layout/content.html'),
				},
				'aside': {
					template  : require('./layout/aside.html'),
					controller: 'AsideCtrl',
				},
				'header': {
					template  : require('./layout/header.html'),
					controller: 'HeaderCtrl',
				},
				'chatbox': {
					template    : require('./app/u-faculty/chatbox/chatbox.html'),
					controller  : 'ChatboxController',
					controllerAs: 'chatbox',
				},
			},
		})
		.state('fullscreen', {
			url     : '/app',
			abstract: false,
			views   : {
				'': {
					template: require('./layout/layout-fullscreen.html'),
				},
				'content': {
					template: require('./layout/content-fullscreen.html'),
				},
				'aside': {
					template  : require('./layout/aside-fullscreen.html'),
					controller: 'AsideCtrl',
				},
				'header': {
					template  : require('./layout/header-fullscreen.html'),
					controller: 'HeaderCtrl',
				},
				'chatbox': {
					template    : require('./app/u-faculty/chatbox/chatbox.html'),
					controller  : 'ChatboxController',
					controllerAs: 'chatbox',
				},
				'footer': {
					template: require('./layout/footer.html'),
				},
			},
		})
		.state('app.unauthorized', {
			abstract: false,
			url     : '/unauthorized',
			template: require('./unauthorized/unauthorized.html'),
			data    : { displayName: ' ' },
		})
		.state('fullscreen.welcomeHome', {
			abstract    : false,
			url         : '/welcomeHome',
			template    : require('./welcome/welcome.html'),
			controller  : 'welcomeCtrl',
			controllerAs: 'wCtrl',
		})
		.state('login', {
			abstract: false,
			url     : '/login',
			content : {
				template: '',
			},
			aside: {
				template: '',
			},
			header: {
				template  : '',
				controller: 'HeaderCtrl',
			},
			template    : require('./login/login.html'),
			controller  : 'loginController',
			controllerAs: '$ctrl',
		})
		.state('loginMessage', {
			abstract    : false,
			url         : '/login-message/:message',
			controller  : 'loginErrorMessageController',
			controllerAs: '$ctrl',
			template    : require('./login/loginErrorMessage.html'),
		})
}



// WEBPACK FOOTER //
// ./src/app.route.js